import { gql } from '@apollo/client';

const schema = {
  list: {
    name: 'shopType',
    serviceName: 'graphql',
    query: gql`
      query shopType($ids: [String]) {
        shopType(ids: $ids) {
          data {
            id
            title
          }
        }
      }
    `,
  },
};

export default schema;
